import { DismissableErrorMessageProps, useDismissableErrorMessage } from '@n2-common/ui';
import { PropsWithChildren, createContext, useContext } from 'react';

type ErrorMessageContextType = (error: DismissableErrorMessageProps['error']) => void;

const ErrorMessageContext = createContext<ErrorMessageContextType | null>(null);

export const ErrorMessageProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const { ErrorOutput, setErrorMessage } = useDismissableErrorMessage();
    return (
        <>
            <ErrorMessageContext.Provider value={setErrorMessage}>{children}</ErrorMessageContext.Provider>
            <ErrorOutput />
        </>
    );
};

export function useErrorMessage() {
    const context = useContext(ErrorMessageContext);
    if (!context) {
        throw new Error('useErrorMessage hook is only useable in tree under ErrorMessageContext element.');
    }
    return context;
}
